module.exports = __webpack_public_path__ + "static/media/Color-Vision-Final.daefd3e2.m4v";